import { useState, cloneElement, Children, ReactNode, isValidElement, ReactElement } from 'react'
import cn from 'clsx'

// Components
import { Dropdown } from '@tracklib/kit'

import styles from './contextmenu.css'

export const DotsLabel = ({ className }: { className?: string }) => (
  <div className={styles.dotWrapper}>
    <span className={cn(styles.dots, className)} />
  </div>
)

type ContextMenuProps = {
  children: Array<ReactNode>
  origin?: 'left' | 'right'
  className?: string
  fitContent?: boolean
  customButton?: ReactNode
  listClassName?: string
}

const ContextMenu = ({ children, origin, className, fitContent, customButton, listClassName }: ContextMenuProps): JSX.Element => {
  const [active, setActive] = useState(false)
  const filteredChildren = children.filter(child => !!child)
  return (
    <Dropdown
      active={active}
      label={customButton || <DotsLabel />}
      onToggle={() => setActive(!active)}
      closesOnBackdropClick
      labelClassName={styles.label}
      listClassName={cn(
        styles.list,
        fitContent ? styles.fitContent : styles.fixedSize,
        origin === 'left' && styles.leftList,
        listClassName,
      )}
      className={className}
    >
      {Children.map(filteredChildren, child => {
        if (isValidElement(child)) {
          return cloneElement(child as ReactElement, {
            closeMenu: () => setActive(false),
          })
        }
        return null
      })}
    </Dropdown>
  )
}

const Item = ({
  icon,
  text,
  onClick,
  closeMenu,
  filled,
  disabled,
  ...props
}: {
  icon?: JSX.Element
  onClick: () => void
  closeMenu?: () => void
  filled?: boolean
  disabled?: boolean
  text: string
}) => {
  const handleClick = () => {
    if (closeMenu) {
      closeMenu()
    }
    return onClick()
  }
  return (
    <Dropdown.Item onClick={handleClick} disabled={disabled} {...props} className={cn(styles.item, filled && styles.filled)}>
      {icon && <span className={styles.icon}>{icon}</span>}
      {text}
    </Dropdown.Item>
  )
}

ContextMenu.Item = Item

export default ContextMenu
